(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5929],{

/***/ 19698:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reviews",
      function () {
        return __webpack_require__(7484);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 46877:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/jocelyn-profile.cc2587af.jpg","height":200,"width":200,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFAABAAAAAAAAAAAAAAAAAAAAAP/EAB0QAAAHAAMAAAAAAAAAAAAAAAABAgMEERIhIlH/xAAUAQEAAAAAAAAAAAAAAAAAAAAE/8QAGxEBAAEFAQAAAAAAAAAAAAAAAQACAwQTIWH/2gAMAwEAAhEDEQA/AByltz0Idc0xdUauuc8FXugAAfWIdinFttI+T//Z"});

/***/ }),

/***/ 45501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ Aggregates; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/page-sections/Aggregates/Aggregates.tsx

function Aggregates() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-7xl pt-22 xl:pt-30",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center xl:flex-row xl:space-x-8 space-y-22 xl:space-y-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center xl:w-72",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-transparent bg-clip-text bg-gradient-to-br from-dawnOrange-500 to-dawnPurple-500 text-6.25xl leading-18 xl:text-7xl font-bold",
                                    children: "75%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "xl:px-6 mt-2 md:mt-6 text-base text-center xl:text-xl max-w-[176px] xl:max-w-none",
                                    children: "less time needed to fall asleep"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center xl:w-72",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-transparent bg-clip-text bg-gradient-to-br from-dawnOrange-500 to-dawnPurple-500 text-6.25xl leading-18 xl:text-7xl font-bold",
                                    children: "80%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-2 md:mt-6 text-base text-center xl:text-xl max-w-[176px] xl:max-w-none",
                                    children: "less time awake in the middle of the night"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center xl:w-72",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-transparent bg-clip-text bg-gradient-to-br from-dawnOrange-500 to-dawnPurple-500 text-6.25xl leading-18 xl:text-7xl font-bold",
                                    children: "60%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "px-6 mt-2 md:mt-6 text-base text-center xl:text-xl max-w-[176px] xl:max-w-none",
                                    children: "decrease in ISI symptoms"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center xl:w-72",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-transparent bg-clip-text bg-gradient-to-br from-dawnOrange-500 to-dawnPurple-500 text-6.25xl leading-18 xl:text-7xl font-bold",
                                    children: "90 min"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "xl:px-10 mt-2 md:mt-6 text-base text-center xl:text-xl max-w-[176px] xl:max-w-none",
                                    children: "increase in total sleep time"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "px-10 mt-16 mb-6 text-base italic text-center xl:text-lg font-inter text-dawnDark-400",
                    children: "Based on users who followed the program for 1 month or more"
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/page-sections/Aggregates/index.ts



/***/ }),

/***/ 47849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* reexport */ Intro; },
  "O": function() { return /* reexport */ IntroBase; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/Link/index.ts + 1 modules
var Link = __webpack_require__(504);
// EXTERNAL MODULE: ./modules/sanity/SanityImage.tsx
var SanityImage = __webpack_require__(88114);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Navbar/Navbar.tsx + 6 modules
var Navbar = __webpack_require__(92595);
// EXTERNAL MODULE: ./components/Gradient/index.ts + 1 modules
var Gradient = __webpack_require__(1824);
// EXTERNAL MODULE: ./components/page-sections/Testimonials/index.ts + 1 modules
var Testimonials = __webpack_require__(39021);
// EXTERNAL MODULE: ./components/page-sections/InThePress/index.ts + 5 modules
var InThePress = __webpack_require__(33732);
;// CONCATENATED MODULE: ./components/page-sections/Intro/Intro.tsx








function Intro(param) {
    var title = param.title, text = param.text, _showCallToAction = param.showCallToAction, showCallToAction = _showCallToAction === void 0 ? true : _showCallToAction, _callToActionText = param.callToActionText, callToActionText = _callToActionText === void 0 ? "Get Started" : _callToActionText, _showTestimonials = param.showTestimonials, showTestimonials = _showTestimonials === void 0 ? false : _showTestimonials, _showInThePressLogos = param.showInThePressLogos, showInThePressLogos = _showInThePressLogos === void 0 ? false : _showInThePressLogos, showHeaderMedia = param.showHeaderMedia, image = param.image, youtubeVideoId = param.youtubeVideoId, internalLinkCallToAction = param.internalLinkCallToAction;
    var buildCallToActionUrl = function buildCallToActionUrl(internalLinkCallToAction) {
        if (internalLinkCallToAction) {
            switch(internalLinkCallToAction._type){
                case "questionnaire":
                    return "/questionnaire/".concat(internalLinkCallToAction.slug.current);
                case "page":
                    return "/".concat(internalLinkCallToAction.slug.current);
                case "post":
                    return "/blog/".concat(internalLinkCallToAction.slug.current);
            }
        }
        return "/questionnaire";
    };
    var hasHeaderMedia = showHeaderMedia && showHeaderMedia !== "none" && (image || youtubeVideoId);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroBase, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "py-22 xl:pt-30 xl:pb-30",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center text-white",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("flex justify-between flex-1 max-w-7xl md:px-7 mx-6", {
                            "xl:flex-row xl:items-center": hasHeaderMedia,
                            "flex-col-reverse": hasHeaderMedia && showHeaderMedia === "image",
                            "flex-col": hasHeaderMedia && showHeaderMedia === "youtubeEmbed"
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("w-full", {
                                    "xl:w-7/12 xl:pr-8 xl:mt-0": hasHeaderMedia
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: classnames_default()("xl:text-5.5xl text-5xl leading-12  xl:leading-18 font-semibold text-center xl:text-left", {
                                            "xl:text-center max-w-3xl mx-auto": !hasHeaderMedia
                                        }),
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: classnames_default()("font-inter mt-4 text-base text-center xl:leading-8 xl:text-xl xl:text-left", {
                                            "xl:text-center max-w-1.5xl mx-auto": !hasHeaderMedia,
                                            "xl:max-w-lg": hasHeaderMedia
                                        }),
                                        children: text
                                    }),
                                    showCallToAction && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()("flex justify-center mt-10 xl:justify-start xl:mt-6", {
                                            "xl:justify-center": !hasHeaderMedia
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                            href: buildCallToActionUrl(internalLinkCallToAction),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "flex items-center justify-center flex-1 max-w-md px-8 py-4 text-sm font-medium tracking-widest text-white uppercase rounded-full xl:flex-none bg-gradient-to-tr from-dawnOrange-500 to-dawnPurple-500 xl:py-6 md:text-base",
                                                children: callToActionText
                                            })
                                        })
                                    })
                                ]
                            }),
                            showHeaderMedia === "image" && image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative mb-10 overflow-hidden xl:flex-1 rounded-xl h-80",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* default */.Z, {
                                    image: image,
                                    fill: true,
                                    width: 400
                                })
                            }),
                            showHeaderMedia === "youtubeEmbed" && youtubeVideoId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative xl:pt-[28.5%] pt-[56.2%] w-full xl:w-[60%] overflow-hidden mt-10 xl:mt-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                    className: "absolute inset-0 w-full h-full rounded-xl",
                                    src: "https://www.youtube.com/embed/".concat(youtubeVideoId),
                                    title: "YouTube video player",
                                    frameBorder: "0",
                                    allowFullScreen: true
                                })
                            })
                        ]
                    })
                }),
                showInThePressLogos && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InThePress/* InThePressLogos */.P, {})
                }),
                showTestimonials && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "xl:mt-30 mt-22",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials/* TestimonialCarousel */.N, {})
                })
            ]
        })
    });
}
function IntroBase(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "overflow-hidden bg-dawnDark-700",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.25,
                        left: "-50rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 8,
                        opacity: 0.15,
                        left: "-60rem",
                        top: "10rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.25,
                        right: "-30rem",
                        top: "-20rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 7,
                        opacity: 0.1,
                        right: "-40rem",
                        top: "-2rem"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
                    children
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/page-sections/Intro/index.ts



/***/ }),

/***/ 41697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ usePreviewSubscription; },
/* harmony export */   "i3": function() { return /* binding */ sanityClient; },
/* harmony export */   "vc": function() { return /* binding */ config; }
/* harmony export */ });
/* unused harmony export useCurrentUser */
/* harmony import */ var next_sanity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81035);

var config = {
    projectId: "4jrvqlog",
    dataset: "production",
    apiVersion: "2021-07-21",
    useCdn: "production" === "production"
};
var usePreviewSubscription = (0,next_sanity__WEBPACK_IMPORTED_MODULE_0__/* .createPreviewSubscriptionHook */ .KF)(config);
var useCurrentUser = (0,next_sanity__WEBPACK_IMPORTED_MODULE_0__/* .createCurrentUserHook */ .Iy)(config);
var sanityClient = (0,next_sanity__WEBPACK_IMPORTED_MODULE_0__/* .createClient */ .eI)(config);


/***/ }),

/***/ 88114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SanityImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_sanity_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61202);
/* harmony import */ var lib_sanity__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41697);






function SanityImage(param) {
    var image = param.image, className = param.className, _fill = param.fill, fill = _fill === void 0 ? false : _fill, _width = param.width, width = _width === void 0 ? 800 : _width, _sizes = param.sizes, sizes = _sizes === void 0 ? "(max-width: 800px) 100vw, 800px" : _sizes;
    var imageProps = (0,next_sanity_image__WEBPACK_IMPORTED_MODULE_2__/* .useNextSanityImage */ .J)(lib_sanity__WEBPACK_IMPORTED_MODULE_3__/* .sanityClient */ .i3, image, {
        imageBuilder: function(imageUrlBuilder, options) {
            return imageUrlBuilder.width(Math.min(width, options.width));
        }
    });
    return fill ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: imageProps.src,
        alt: image.alt,
        loader: imageProps.loader,
        layout: "fill",
        sizes: sizes,
        objectFit: "cover",
        className: className
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, imageProps), {
        alt: image.alt,
        layout: "responsive",
        sizes: sizes,
        className: className
    }));
};


/***/ }),

/***/ 7484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Reviews; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/page-sections/Intro/index.ts + 1 modules
var Intro = __webpack_require__(47849);
// EXTERNAL MODULE: ./components/page-sections/CallToAction/index.ts + 1 modules
var CallToAction = __webpack_require__(31437);
// EXTERNAL MODULE: ./components/page-sections/Aggregates/index.ts + 1 modules
var Aggregates = __webpack_require__(45501);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./public/images/people/jocelyn-profile.jpg
var jocelyn_profile = __webpack_require__(46877);
;// CONCATENATED MODULE: ./modules/reviews/TestimonialVideo.tsx




var reviews = [
    {
        name: "Dina",
        quote: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: "\u201CI was waking up feeling like I got 1-2 hours of sleep.\u201D"
            });
        },
        reviewText: "\u201CI was up all night thinking and stressing about all the things I had to do\u2026and it was so difficult to actually fall asleep\u201D.",
        videoUrl: "https://youtube.com/embed/1JBReY44Ky4",
        title: "Feminine Embodiment Coach",
        profileImg: jocelyn_profile/* default */.Z
    },
    {
        name: "Jocelyn",
        quote: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: "\u201CYou will sleep soon. I swear.\u201D"
            });
        },
        reviewText: "\u201CI had a really great experience with Dawn because I\u2019m now sleeping through the night...I really like the structure of how it [Dawn] works and the lessons were really helpful in understanding that I\u2019m normal.\u201D",
        videoUrl: "https://www.youtube.com/embed/KUIs1O3jQvo",
        title: "Feminine Embodiment Coach",
        profileImg: jocelyn_profile/* default */.Z
    },
    {
        name: "Feb",
        quote: '"Moms struggle with Insomnia"',
        reviewText: "\"How do you survive raising 3 boys under 3 years old? Well the answer is sleep. Dawn has therapists that make sure you're getting the appropriate amount of sleep.\u201D",
        videoUrl: "https://youtube.com/embed/A2Tiwxkox-s",
        title: "Feminine Embodiment Coach",
        profileImg: jocelyn_profile/* default */.Z
    }, 
];
function Testimonial(param) {
    var videoUrl = param.videoUrl, quote = param.quote, name = param.name, reviewText = param.reviewText, reverse = param.reverse;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col justify-center flex-1 max-w-5xl space-y-10 md:".concat(reverse ? "flex-row" : "flex-row-reverse"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative md:pt-[48.5%] pt-[134%] w-full md:w-[40.5%] ".concat(reverse ? "md:mr-[25%]" : "md:ml-[25%]", " overflow-hidden"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    className: "absolute inset-0 w-full h-full rounded-xl",
                    src: videoUrl,
                    title: "YouTube video player",
                    frameBorder: "0",
                    allowFullScreen: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center flex-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-6xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "md:text-5xl text-2.5xl leading-8 font-semibold md:leading-14",
                            children: typeof quote === "function" ? quote() : quote
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-4 text-base md:leading-8 md:text-xl font-inter",
                            children: reviewText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center mt-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ml-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "text-base font-semibold md:text-xl",
                                    children: [
                                        "\u2013 ",
                                        name
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}
function TestimonialVideo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col items-center gap-16 px-6 py-22 md:py-30",
        children: reviews.map(function(x, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonial, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, x), {
                reverse: index % 2 === 0
            }), "".concat(x.name, "_testimonial"));
        })
    });
}

// EXTERNAL MODULE: ./components/Gradient/index.ts + 1 modules
var Gradient = __webpack_require__(1824);
// EXTERNAL MODULE: ./components/page-sections/Testimonials/index.ts + 1 modules
var Testimonials = __webpack_require__(39021);
;// CONCATENATED MODULE: ./components/page-sections/WhoUsesDawn/WhoUsesDawn.tsx



function WhoUsesDawn() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "overflow-hidden bg-dawnDark-700 py-22 md:pt-30 md:pb-30",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.15,
                        left: "-40rem",
                        top: "-15rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 8,
                        opacity: 0.15,
                        left: "-60rem",
                        top: "-10rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.15,
                        right: "-30rem",
                        top: "-10rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 7,
                        opacity: 0.1,
                        right: "-40rem",
                        top: "-10rem"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative space-y-22 md:space-y-30",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center mx-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col md:flex-row max-w-3.5xl md:mx-auto text-white space-y-4 md:space-y-0 md:space-x-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex-1 text-2.5xl leading-8 md:text-5xl md:leading-14 font-semibold",
                                    children: "Who uses Dawn?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "max-w-[502px] text-base md:text-xl md:leading-8 font-inter",
                                    children: "Our patients range from new parents who struggled with insomnia to office workers who could not stop stressing as they tried to sleep. We have helped patients ages 18, to 70, with some just recently beginning to struggle with sleep and others who have been fighting to sleep for years before consulting with Dawn."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials/* TestimonialCarousel */.N, {})
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/page-sections/WhoUsesDawn/index.ts


// EXTERNAL MODULE: ./components/page-sections/InThePress/index.ts + 5 modules
var InThePress = __webpack_require__(33732);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-masonry-css/dist/react-masonry-css.module.js
var react_masonry_css_module = __webpack_require__(40827);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./utils/range.ts
var range = __webpack_require__(97191);
;// CONCATENATED MODULE: ./components/page-sections/AppStoreReviews/AppStoreReviews.tsx







var appStoreReviewsData = [
    {
        stars: 5,
        title: "No more insomnia",
        text: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "I saw a reddit user said he was successful with this app. Thats why I have it a try. Before Sleepedy, I get zero sleep a night, continued for days after. After using this for 2 week, i start sleeping 2-4 hour/night. 3 rd week it increased to 6 hours. Im on week 4 and sleeping 7.5 hours/night. The coaches are so responsive and easy to reach to answer your questions and cheer you up. Takes less than 5 mins to fall as sleep. If you should know, I spent almost lots of money on every other methods: hypnosis, psychiatrist, working out...you name it. I spent lots of time crying hopelessly and thought I would never sleep again. If you suffer like I do, give it a try. I promise, you will sleep."
        })
    },
    {
        stars: 5,
        title: "Major life improvement",
        text: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "I came across Sleepedy not knowing about CBT-I before, but was encouraged by all of the science behind it. I am a little over 3 weeks in to the program now and my sleep has changed dramatically for the better. I previously dreaded bed time because of the trouble I had falling asleep, most nights wasting hours in bed before I was able to fall asleep. I now have been keeping a regular sleep schedule and have been falling asleep within 10-15 mins... something I was never able to do before. I am now also waking up during the night less (before Sleepedy I would wake at least 3 times during the night, I\u2019m now down to 0 or 1). The app has made it really easy to track my progress and stay accountable to myself. Sleepedy has been a huge improvement to my life and I\u2019m real glad I gave it a try."
        })
    },
    {
        stars: 5,
        title: "Sleeping soundly again!",
        text: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "I recently started not sleeping almost at all. I was actually using reddit to ask other people for their method of fixing their sleep schedule when a kind user recommended this app! It was very helpful for setting sleep goals and was especially nice to be able to talk with a sleep coach. Highly recommend!"
        })
    },
    {
        stars: 5,
        title: "Great start for a well-needed app!",
        text: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "I tried this app when it was first released. The user experience is quite slick and well-crafted, and one can see that a lot of effort took place during its implementation.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "After adding my sleep information, I was immediately paired with a sleep expert. It\u2019s still early to say whether the application will truly help improve my overall sleep, but I can certainly say that I am feeling more confident when it comes to finding the right resources for sleep improvement. The simple knowledge base in the application has already made me more cognizant of the daily activities that may affect my sleep. Having an assigned sleep expert is also very beneficial since one can ask questions and discuss any concerns, and receive advice almost immediately.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Looking forward to see how this application evolves"
            ]
        })
    }, 
];
function AppStoreReviewBox(param) {
    var index = param.index, isExpanded = param.isExpanded, setExpandedIndex = param.setExpandedIndex, stars = param.stars, title = param.title, text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mb-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "p-8 text-white bg-white rounded-2xl bg-opacity-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex",
                    children: (0,range/* range */.w)({
                        start: 0,
                        end: stars
                    }).map(function(n) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            className: "fill-current text-dawnOrange-500",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M21.947 9.17901C21.8842 8.99388 21.7685 8.83121 21.6142 8.71107C21.46 8.59094 21.2739 8.51861 21.079 8.50301L15.378 8.05001L12.911 2.58901C12.8325 2.41313 12.7047 2.26374 12.5431 2.15887C12.3815 2.05401 12.193 1.99815 12.0004 1.99805C11.8077 1.99794 11.6192 2.05359 11.4575 2.15828C11.2957 2.26296 11.1678 2.41221 11.089 2.58801L8.62203 8.05001L2.92103 8.50301C2.72948 8.51819 2.54636 8.58823 2.39358 8.70475C2.2408 8.82127 2.12482 8.97934 2.05952 9.16004C1.99422 9.34075 1.98236 9.53645 2.02537 9.72372C2.06838 9.91099 2.16443 10.0819 2.30203 10.216L6.51503 14.323L5.02503 20.775C4.97978 20.9703 4.99428 21.1747 5.06665 21.3617C5.13901 21.5486 5.26589 21.7095 5.43083 21.8235C5.59577 21.9374 5.79115 21.9991 5.99161 22.0007C6.19208 22.0022 6.38837 21.9434 6.55503 21.832L12 18.202L17.445 21.832C17.6154 21.9451 17.8162 22.0033 18.0207 21.9988C18.2251 21.9944 18.4232 21.9274 18.5884 21.8069C18.7536 21.6865 18.878 21.5183 18.9448 21.3251C19.0116 21.1318 19.0176 20.9228 18.962 20.726L17.133 14.326L21.669 10.244C21.966 9.97601 22.075 9.55801 21.947 9.17901V9.17901Z"
                            })
                        }, n);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("mt-4 text-base md:text-xl md:leading-8 font-bold", {
                        "md:truncate": !isExpanded
                    }),
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("text-base md:text-xl md:leading-8 font-inter", {
                        "line-clamp-2": !isExpanded
                    }),
                    children: text
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: function() {
                        return setExpandedIndex(isExpanded ? -1 : index);
                    },
                    className: "mt-2 text-base text-dawnDark-200 font-inter",
                    children: isExpanded ? "Read less" : "Read more"
                })
            ]
        })
    });
}
function AppStoreReviews() {
    var ref = (0,react.useState)(-1), expandedIndex = ref[0], setExpandedIndex = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "overflow-hidden bg-dawnDark-700 py-22 md:pt-30 md:pb-30",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 8,
                        opacity: 0.1,
                        left: "-63rem",
                        top: "-2rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 6,
                        opacity: 0.15,
                        left: "-45rem",
                        top: "0rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.1,
                        right: "-62rem",
                        top: "1rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 8,
                        opacity: 0.1,
                        right: "-53rem",
                        top: "2rem"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "max-w-3.5xl mx-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "font-semibold text-center text-2.5xl leading-8 text-white md:text-5xl md:leading-14",
                                    children: "From the App Store"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_masonry_css_module/* default */.Z, {
                                    breakpointCols: {
                                        default: 2,
                                        768: 1
                                    },
                                    className: "flex w-auto mt-8 -ml-8",
                                    columnClassName: "pl-8 bg-clip-padding",
                                    children: appStoreReviewsData.map(function(appStoreReview, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppStoreReviewBox, {
                                            index: index,
                                            isExpanded: index === expandedIndex,
                                            setExpandedIndex: setExpandedIndex,
                                            stars: appStoreReview.stars,
                                            title: appStoreReview.title,
                                            text: appStoreReview.text
                                        }, index);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "https://apps.apple.com/us/app/dawn-health/id1487849164",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "block mt-8 text-base text-center text-dawnOrange-500 md:mt-10 md:text-xl md:leading-8 font-inter",
                            children: "More from the App Store"
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/page-sections/AppStoreReviews/index.ts


;// CONCATENATED MODULE: ./pages/reviews.tsx









function Reviews() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Reviews | Dawn Health"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Reviews."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "initial-scale=1.0, width=device-width"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "text-dawnDark-500",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Intro/* Intro */.p, {
                        title: "Dawn has improved sleep for thousands of customers",
                        text: "Sleeping shouldn\u2019t be hard, so we designed a CBT-I based program that makes it easier. Most customers sleep better after 6 sessions with a Dawn therapist.",
                        showCallToAction: true,
                        callToActionText: "Get started"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Aggregates/* Aggregates */._, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialVideo, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhoUsesDawn, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InThePress/* InThePress */.C, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppStoreReviews, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction/* CallToAction */.J, {
                        title: "Cure your insomnia today.",
                        text: "Craving good sleep? Talk to a sleep coach and find out more about Dawn\u2019s program for curing sleep problems"
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 97191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ range; }
/* harmony export */ });
function range(param) {
    var start = param.start, end = param.end, _step = param.step, step = _step === void 0 ? 1 : _step;
    return Array.from(Array.from(Array(Math.ceil((end - start) / step)).keys()), function(x) {
        return start + x * step;
    });
}


/***/ }),

/***/ 40827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
const defaultProps = {
  breakpointCols: undefined,
  // optional, number or object { default: number, [key: number]: number }
  className: undefined,
  // required, string
  columnClassName: undefined,
  // optional, string
  // Any React children. Typically an array of JSX items
  children: undefined,
  // Custom attributes, however it is advised against
  // using these to prevent unintended issues and future conflicts
  // ...any other attribute, will be added to the container
  columnAttrs: undefined,
  // object, added to the columns
  // Deprecated props
  // The column property is deprecated.
  // It is an alias of the `columnAttrs` property
  column: undefined
};
const DEFAULT_COLUMNS = 2;

class Masonry extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props); // Correct scope for when methods are accessed externally

    this.reCalculateColumnCount = this.reCalculateColumnCount.bind(this);
    this.reCalculateColumnCountDebounce = this.reCalculateColumnCountDebounce.bind(this); // default state

    let columnCount;

    if (this.props.breakpointCols && this.props.breakpointCols.default) {
      columnCount = this.props.breakpointCols.default;
    } else {
      columnCount = parseInt(this.props.breakpointCols) || DEFAULT_COLUMNS;
    }

    this.state = {
      columnCount
    };
  }

  componentDidMount() {
    this.reCalculateColumnCount(); // window may not be available in some environments

    if (window) {
      window.addEventListener('resize', this.reCalculateColumnCountDebounce);
    }
  }

  componentDidUpdate() {
    this.reCalculateColumnCount();
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener('resize', this.reCalculateColumnCountDebounce);
    }
  }

  reCalculateColumnCountDebounce() {
    if (!window || !window.requestAnimationFrame) {
      // IE10+
      this.reCalculateColumnCount();
      return;
    }

    if (window.cancelAnimationFrame) {
      // IE10+
      window.cancelAnimationFrame(this._lastRecalculateAnimationFrame);
    }

    this._lastRecalculateAnimationFrame = window.requestAnimationFrame(() => {
      this.reCalculateColumnCount();
    });
  }

  reCalculateColumnCount() {
    const windowWidth = window && window.innerWidth || Infinity;
    let breakpointColsObject = this.props.breakpointCols; // Allow passing a single number to `breakpointCols` instead of an object

    if (typeof breakpointColsObject !== 'object') {
      breakpointColsObject = {
        default: parseInt(breakpointColsObject) || DEFAULT_COLUMNS
      };
    }

    let matchedBreakpoint = Infinity;
    let columns = breakpointColsObject.default || DEFAULT_COLUMNS;

    for (let breakpoint in breakpointColsObject) {
      const optBreakpoint = parseInt(breakpoint);
      const isCurrentBreakpoint = optBreakpoint > 0 && windowWidth <= optBreakpoint;

      if (isCurrentBreakpoint && optBreakpoint < matchedBreakpoint) {
        matchedBreakpoint = optBreakpoint;
        columns = breakpointColsObject[breakpoint];
      }
    }

    columns = Math.max(1, parseInt(columns) || 1);

    if (this.state.columnCount !== columns) {
      this.setState({
        columnCount: columns
      });
    }
  }

  itemsInColumns() {
    const currentColumnCount = this.state.columnCount;
    const itemsInColumns = new Array(currentColumnCount); // Force children to be handled as an array

    const items = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(this.props.children);

    for (let i = 0; i < items.length; i++) {
      const columnIndex = i % currentColumnCount;

      if (!itemsInColumns[columnIndex]) {
        itemsInColumns[columnIndex] = [];
      }

      itemsInColumns[columnIndex].push(items[i]);
    }

    return itemsInColumns;
  }

  renderColumns() {
    const {
      column,
      columnAttrs = {},
      columnClassName
    } = this.props;
    const childrenInColumns = this.itemsInColumns();
    const columnWidth = `${100 / childrenInColumns.length}%`;
    let className = columnClassName;

    if (className && typeof className !== 'string') {
      this.logDeprecated('The property "columnClassName" requires a string'); // This is a deprecated default and will be removed soon.

      if (typeof className === 'undefined') {
        className = 'my-masonry-grid_column';
      }
    }

    const columnAttributes = _objectSpread(_objectSpread(_objectSpread({}, column), columnAttrs), {}, {
      style: _objectSpread(_objectSpread({}, columnAttrs.style), {}, {
        width: columnWidth
      }),
      className
    });

    return childrenInColumns.map((items, i) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", _extends({}, columnAttributes, {
        key: i
      }), items);
    });
  }

  logDeprecated(message) {
    console.error('[Masonry]', message);
  }

  render() {
    const _this$props = this.props,
          {
      // ignored
      children,
      breakpointCols,
      columnClassName,
      columnAttrs,
      column,
      // used
      className
    } = _this$props,
          rest = _objectWithoutProperties(_this$props, ["children", "breakpointCols", "columnClassName", "columnAttrs", "column", "className"]);

    let classNameOutput = className;

    if (typeof className !== 'string') {
      this.logDeprecated('The property "className" requires a string'); // This is a deprecated default and will be removed soon.

      if (typeof className === 'undefined') {
        classNameOutput = 'my-masonry-grid';
      }
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", _extends({}, rest, {
      className: classNameOutput
    }), this.renderColumns());
  }

}

Masonry.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["Z"] = (Masonry);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9122,5329,5430,1421,1310,2595,1437,2232,9774,2888,179], function() { return __webpack_exec__(19698); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);